import './index.scss';
import marked from 'marked';
import hljs from 'highlight.js';
import 'highlight.js/styles/atom-one-dark.css';

/* eslint-disable max-len,no-console */
const Icons: any = {
  alert: '<?xml version="1.0" encoding="UTF-8"?><svg width="22" height="22" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" fill="#FFFFFF" fill-opacity="0.01"/><path fill-rule="evenodd" clip-rule="evenodd" d="M24 5L2 43H46L24 5Z" fill="#FFF" stroke="#FFA900" stroke-width="4" stroke-linejoin="round"/><path d="M24 35V36" stroke="#FFA900" stroke-width="3" stroke-linecap="round"/><path d="M24 19.0005L24.0083 29" stroke="#FFA900" stroke-width="3" stroke-linecap="round"/></svg>',
  copy: '<?xml version="1.0" encoding="UTF-8"?><svg width="16" height="16" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g><rect width="48" height="48" fill="#FFFFFF" fill-opacity="0.01"/><g><rect width="48" height="48" fill="#FFFFFF" fill-opacity="0.01"/><path d="M12 11.927V7C12 5.34315 13.3431 4 15 4H41C42.6569 4 44 5.34315 44 7V33C44 34.6569 42.6569 36 41 36H36.0174" stroke="#ffffff" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/><rect x="4" y="12" width="32" height="32" rx="3" fill="#ffffff" stroke="#ffffff" stroke-width="3" stroke-linejoin="round"/></g></g></svg>',
};

const renderer = {
  code(text: string, lang: string) {
    if (lang === 'xcodeblock') {
      const reg = /\(code(.*?)\)((\s|\S)+?)\(\/code\)/g;
      const xlangs: string[] = [];
      const slangs: string[] = [];
      const code: string[] = [];
      const originCode: string[] = [];

      text.replace(reg, (txt: string, args: string, str: string) => {
        const xlang = args.split(' ')[2];
        const slang = args.split(' ')[1];
        xlangs.push(xlang);
        slangs.push(slang);
        code.push(showCodeLight(xlang, str));
        originCode.push(str);
        return '';
      });

      return renderMKCode(xlangs, slangs, code);
    }
    if (lang === 'xtable') {
      const rows = text.split('\n');
      if (rows.length < 3) {
        return '';
      }
      while (!rows[rows.length - 1]) {
        rows.pop();
      }

      return renderMKTable(rows);
    }
    if (['alert', 'confirm', 'warn'].includes(lang)) {
      return renderMKTips(text, lang);
    }

    return `<pre>${showCodeLight(lang, text)}</pre>`;
  },
  link(href: string, title: string, text: string) {
    if (title === undefined) {
      // <span class="copy-link" data-clipboard-text='${href}'>${svg}</span>`
      return `<span class="a-color">${href}</span>`;
    }
    return `<a href="${href}" target="_blank">${text}</a>`;
  },
};

marked.use({ renderer });

function renderMKCode(langs: string[], slangs: string[], codes: string[]) {
  const svgString = `<span class="xcodeblock_cope_svg">${Icons.copy}</span>`;
  let htmlString = `<div class="mk-xcodeblock"><div class="mk-xcodeblock-header" style="display: ${slangs.length === 1 ? 'none' : 'flex'}">`;
  htmlString += `${slangs.map((lang, idx) => `<div class="${idx === 0 ? 'header_item active' : 'header_item'}"><span>${lang}</span></div>`).join('')}</div>`;

  htmlString += `<div class="mk-xcodeblock-code"><div class="mk-xcodeblock-code-inner">${codes.map((code, idx) => `<div class='xcodeblock xcodeblock-${langs[idx]} ${idx === 0 ? 'active' : ''}' >${code.replace(/^\n/g, '')}</div>`).join('')}${svgString}</div></div></div>`;
  return htmlString;
}

function renderMKTable(table: string[]) {
  const header = table[0];
  const body = table.slice(2, table.length);
  const headerArr = header.replace(/(^\|)|(\|)$/g, '').split('|');
  const col = headerArr.length;
  const bodyArr = body.map((item) => item.replace(/(^\|)|(\|)$/g, '').split('|'));
  const htmlString = `<table>${renderColGroup(headerArr)}${renderHeader(headerArr)}${renderBody(bodyArr, col)}</table>`;
  return htmlString;
}

function renderColGroup(headerArr: string[]) {
  const thWidth = [30, 10, 60];
  const head = headerArr.map((item, key) => {
    let width: any = thWidth[key];
    item.replace(/\{(.*?)\}/g, ($1, $2) => {
      width = $2;
      return '';
    });
    width = +width ? `${width}%` : width;
    return `<col width="${width}">`;
  });
  return `<colgroup>${head.join('')}</colgroup>`;
}

function renderHeader(headerArr: string[]) {
  const head = headerArr.map((item, key) => {
    const str = item.replace(/\{(.*?)\}/g, () => '');
    return `<th style="padding-left:${key === 0 ? '30px' : '12px'}">${str}</th>`;
  });

  return `<thead>${head.join('')}</thead>`;
}

function renderBody(bodyArr: Array<string[]>, col: number) {
  const body = bodyArr.map((item, i) => {
    let nextLevel = 0;
    let curLevel = 0;
    const nextTd = bodyArr[i + 1] || [];
    if (/^#+/g.test(item[0])) {
      curLevel = item[0].length;
    }
    if (/^#+/g.test(nextTd[0])) {
      nextLevel = nextTd[0].length;
    }

    return `<div><tr class="level-${curLevel}" data-key="${curLevel}">${compileItem(item, curLevel, nextLevel, i, col)}</tr></div>`;
  }).join('');

  //  生成行
  function compileItem(item: string[], curLevel: number, nextLevel: number, index: number, cols: number) {
    const data = [...item];
    if (curLevel) { data.shift(); }

    let indent = '';
    if (nextLevel > curLevel) {
      indent = `<span data-index=${index}
        class="iconfont icon-unfold" 
        style="margin-right: 4px; position: absolute;left: -18px;top: 0px;margin-right: 2px;font-size: 16px;cursor: pointer; color: #999;font-weight: normal;">
      </span>`;
    }
    const colspan = cols - data.length + 1;

    return data.map((td, i) => {
      let tdString = compilelink(td);
      tdString = compileCode(tdString);
      return `<td style="${(i === 0) ? `padding-left:${(curLevel + 1) * 30}px` : ''}"  colspan="${(i === data.length - 1) ? colspan : ''}">
        <div class="${i === 0 ? 'tdData' : ''}">
        ${i === 0 ? indent : ''}${compileTag(tdString)}
        </div>
      </td>`;
    }).join('');
  }
  //  解析标签
  function compileTag(text: string) {
    let string = text;
    if (/<Empty>(.*)<\/Empty>/g.test(text)) {
      string.replace(/<Empty>(.*)<\/Empty>/, ($1, $2) => {
        string = $2;
        return '';
      });
      return string;
    }
    text.replace(/\{(.*?)\}/g, ($1, $2) => {
      let tag = '';
      let str = $2;
      const isTag = text[0] !== '{';

      if ($2 && isTag) {
        string = string.replace($1, '');
        if (str[0] === '$') {
          tag = 'tag-update';
          str = $2.replace('$', '');
          string = `<div>${string}<span class="tag ${tag}">${str}</span></div>`;
          return '';
        }
        if (str[0] === '&') {
          tag = 'tag-add';
          str = $2.replace('&', '');
          string = `<div>${string}<span class="tag ${tag}">${str}</span></div>`;
          return '';
        }
        if (str[0] === '+') {
          tag = 'tag-required';
          str = $2.replace('+', '');
        }
        if (str[0] === '-') {
          tag = 'tag-remove';
          str = $2.replace('-', '');
        }
        string = `${string}<span class="tag ${tag}">${str}</span>`;
        return '';
      }
      return $1;
    });

    return string;
  }
  //  解析url []()
  function compilelink(text: string) {
    return text.replace(/\[(.*?)\]\((.*?)\)/g, (content, linkText, src) => (text ? `<a href='${src}' target='_blank'>${linkText}</a>` : ''));
  }
  // 解析 ``
  function compileCode(text: string) {
    return text.replace(/`(.*?)`/g, (content, code) => (code ? `<code>${code}</code>` : ''));
  }

  return body;
}

function showCodeLight(lang: string, str: string) {
  // eslint-disable-next-line no-param-reassign
  if (lang && hljs.getLanguage(lang)) {
    try {
      return hljs.highlightAuto(str, [lang]).value;
    } catch (err) {
      console.log(err);
      return str;
    }
  }
  return str;
}

// 解析 提示框
function renderMKTips(text: string, lang: string) {
  return `<div class="mk_render_tips">
  ${Icons[lang]}
  ${marked.parse(text)}
  </div>`;
}

export default marked;
